<div class="wizard horizontal mt-1 mb-2">
  <ng-container *ngFor="let step of steps; let index = index; let isLast = last">
    <div class="wizard-box" [class.active]="index === currentStepIndex" [class.completed]="step.completed"
      [class.disabled]="!canNavigateToStep(index)">
      <div class="wizard-box-icon" (click)="goToStep(index)" [class.clickable]="canNavigateToStep(index)">
        <span *ngIf="!step.icon && !step.completed">{{ index + 1 }}</span>
        <i *ngIf="step.icon && !step.completed" [attr.data-feather]="step.icon" size="18"></i>
      </div>
      <span>{{ step.label }}</span>
    </div>
    <div *ngIf="!isLast" class="wizard-icon">
      <i data-feather="chevron-right" size="18"></i>
    </div>
  </ng-container>
</div>
<section>
  <ng-content></ng-content>
</section>
<footer *ngIf="!hideFooter" class="flex justify-content-end gap-2 mt-2">
  <ng-container *ngIf="hideClearAndSave">
    <button type="button" class="btn btn-light" (click)="onCancel.emit()">
      Fechar
    </button>
  </ng-container>
  <ng-container *ngIf="!hideClearAndSave">
    <button type="button" class="btn btn-light-danger text-danger" (click)="onClear.emit()" [disabled]="isSubmitting">
      Limpar
    </button>
    <button type="button" class="btn btn-light" (click)="onBackOrCancel()" [disabled]="isSubmitting">
      {{ currentStepIndex === 0 ? 'Cancelar' : 'Voltar' }}
    </button>
    <button type="button" class="btn btn-gradient-primary btn-primary-action" (click)="onNextOrSubmit()"
      [disabled]="isSubmitting">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span *ngIf="!isSubmitting">{{ currentStepIndex === steps.length - 1 ? 'Salvar' : 'Próximo' }}</span>
    </button>
  </ng-container>
</footer>